const GrowthIcon = ({ className = '' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M66.058 22.0648C67.8914 12.5051 59.4985 4.1122 49.9387 5.94561L22.4916 11.2095C16.525 12.3538 11.7534 16.8702 10.2374 22.7387C7.2107 34.4554 18.0768 45.1638 29.7441 41.7327C30.0663 41.6379 30.3656 41.9373 30.2709 42.2595C26.8399 53.9268 37.5481 64.793 49.265 61.7662C55.1335 60.2503 59.6498 55.4786 60.7941 49.5121L66.058 22.0648Z"
        fill="#FF9060"
      />
      <path
        d="M13.485 48.9727C14.3637 48.0941 14.3637 46.6694 13.485 45.7908C12.6063 44.9121 11.1817 44.9121 10.303 45.7908L6.06038 50.0334C5.1817 50.9121 5.1817 52.3367 6.06038 53.2154C6.93906 54.0941 8.36368 54.0941 9.24236 53.2154L13.485 48.9727Z"
        fill="#FF9060"
      />
      <path
        d="M24.0916 47.9121C24.9703 48.7908 24.9703 50.2154 24.0916 51.0941L19.849 55.3367C18.9703 56.2154 17.5457 56.2154 16.667 55.3367C15.7883 54.458 15.7883 53.0334 16.667 52.1547L20.9096 47.9121C21.7883 47.0334 23.2129 47.0334 24.0916 47.9121Z"
        fill="#FF9060"
      />
      <path
        d="M26.2129 61.7007C27.0916 60.822 27.0916 59.3974 26.2129 58.5187C25.3342 57.64 23.9096 57.64 23.0309 58.5187L18.7883 62.7613C17.9096 63.64 17.9096 65.0646 18.7883 65.9433C19.667 66.822 21.0916 66.822 21.9703 65.9433L26.2129 61.7007Z"
        fill="#FF9060"
      />
    </svg>
  )
}

export default GrowthIcon
